/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Zatím nemáte účet?`
};

const da_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ingen konto endnu?`
};

const de_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Noch kein Konto?`
};

const en_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `New here?`
};

const es_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `¿Aún no tienes cuenta?`
};

const fr_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Pas encore de compte ?`
};

const hu_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Még nem regisztráltál?`
};

const it_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Non hai ancora un account?`
};

const nl_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Nog geen account?`
};

const pl_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Nie masz konta?`
};

const pt_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ainda não tem uma conta?`
};

const sv_account_register_title = /** @type {(inputs: {}) => string} */ () => {
	return `Inget konto än?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_register_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_register_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_register_title", locale)
	if (locale === "cs") return cs_account_register_title(inputs)
	if (locale === "da") return da_account_register_title(inputs)
	if (locale === "de") return de_account_register_title(inputs)
	if (locale === "en") return en_account_register_title(inputs)
	if (locale === "es") return es_account_register_title(inputs)
	if (locale === "fr") return fr_account_register_title(inputs)
	if (locale === "hu") return hu_account_register_title(inputs)
	if (locale === "it") return it_account_register_title(inputs)
	if (locale === "nl") return nl_account_register_title(inputs)
	if (locale === "pl") return pl_account_register_title(inputs)
	if (locale === "pt") return pt_account_register_title(inputs)
	return sv_account_register_title(inputs)
};
export { account_register_title as "account.register_title" }